/* global swal  angular*/
import './style.less';
import { controller, controllerAs, template } from 'modals/manageEventExternal';

export default function($log, $uibModal, $uibModalStack) {
  'ngInject';

  const vm = this;

  vm.$onInit = activate;
  vm.activate = activate;

  vm.openManage = () => {
    $uibModalStack.dismissAll();
    $uibModal.open({
      backdrop: true,
      size: 'lg',
      template,
      controller,
      controllerAs,
      resolve: {
        external: () => vm.external
      }
    });
  };

  function activate() {
    $log.debug('Event External Component Activated');
  }
}



// WEBPACK FOOTER //
// ./src/app/components/admin/eventManager/event/eventExternal/controller.js